








































import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { ImelessTextarea } from "../../../system";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class TextInputArea extends Mixins(ModelEditableMixin) {
  @Prop(Boolean)
  isEditable: boolean;
  @Prop(Boolean)
  isFocused: boolean;
  @Prop(Boolean)
  isMultiLine: boolean;
  @Prop()
  textStyle: any;
  @Prop(Boolean)
  shouldUseImelessTextarea: boolean;
  @Prop(Number)
  transformTextScale: number;

  @Emit("update:isFocused")
  emitUpdateIsFocused(value: boolean): any {}

  @Emit()
  updateInputElement(element: HTMLInputElement): any {}

  getInputElement(): HTMLInputElement {
    if (this.isEditable) {
      if (this.shouldUseImelessTextarea && !!this.$refs.imelessTextarea) {
        return (this.$refs.imelessTextarea as ImelessTextarea).getEditor() as unknown as HTMLInputElement;
      }
      if (this.isMultiLine) {
        return this.$refs.textarea as HTMLInputElement;
      } else {
        return this.$refs.input as HTMLInputElement;
      }
    }
    return null;
  }

  @Watch("isFocused", { immediate: true })
  updateIsFocused(newValue: boolean, oldValue: boolean): void {
    this.$nextTick(() => {
      this.refreshFocus();
    });
  }

  @Watch("isEditable", { immediate: true })
  updateIsEditable(newValue: boolean, oldValue: boolean): void {
    this.$nextTick(() => {
      this.refreshFocus();
      const element = this.getInputElement();
      this.updateInputElement(element);
      if (this.isEditable && this.isFocused) {
        element.select();
      }
    });
  }

  private refreshFocus(): void {
    const element = this.getInputElement();
    // IEは一度フォーカスを切らないとちゃんとフォーカスが当たらないので暫定対応
    if (!this.isFocused || element == null) { return; }

    element.blur();
    element.focus();
  }

  @Emit()
  blur(): void {}

  @Emit()
  compositionstart(e: CompositionEvent): void {}

  @Emit()
  compositionupdate(e: CompositionEvent): void {}

  @Emit()
  compositionend(e: CompositionEvent): void {}
}
